import { createFileRoute } from '@tanstack/react-router';

import { LabelsSection } from '@/features/settings/components/LabelsSection';
import { useWorkspace } from '@/features/workspaces';

export const Route = createFileRoute(
  '/workspaces/$workspaceId/settings/labels',
)({
  component: LabelsRoute,
});

export function LabelsRoute() {
  const { workspaceId } = Route.useParams();
  const { data: workspace } = useWorkspace(workspaceId);
  if (!workspace) return null;
  return (
    <LabelsSection
      workspaceId={workspaceId}
      registry={workspace.labels}
      tasks={workspace.tasks}
    />
  );
}
